
import Vue from "vue";
import Search from "@/components/Search.vue";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import { Component } from "vue-property-decorator";
import TagsModel from "@/models/Faq/TagsModel";
import api from "@/api";
@Component({
  components: {
    Search,
    MenuFooter,
  },
})
export default class Faq extends Vue {
  mounted() {
    this.getListFaq();
  }
  displayLoading = true;
  displayFaq = false;

  listTags: TagsModel[] = [];

  getListFaq() {
    this.displayLoading = true;
    return new Promise((resolve, reject) => {
      api.faq
        .getListFaq()
        .then((response) => {
          if (response.data.code === 200) {
            this.listTags = [...response.data.data];
            this.displayLoading = false;
            this.displayFaq = true;
            resolve(response);
          }
        })
        .catch((err: any) => {
          this.$swal("Error", err?.response?.data?.message, "error");
          reject(err);
        });
    });
  }
}
